import { Stack } from '@mui/material'
import { AgentThoughtTraceBlock } from './AgentThoughtTraceBlock'

/**
 * @param {{ paragraphs: string[], streaming?: boolean }} props
 */
export function AgentThoughtTracePanel({ paragraphs, streaming = false }) {
  if (!paragraphs || paragraphs.length === 0) return null
  const lastIndex = paragraphs.length - 1
  return (
    <Stack sx={{ width: '100%', minWidth: 0, gap: 1.25, alignItems: 'stretch' }}>
      {paragraphs.map((text, i) => (
        <AgentThoughtTraceBlock
          key={i}
          streaming={streaming}
          isActive={streaming && i === lastIndex}
        >
          {text}
        </AgentThoughtTraceBlock>
      ))}
    </Stack>
  )
}
